/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import Layout from '../containers/layout';
import VisualComposer from '../components/VisualComposer';
import HeaderPage from '../components/HeaderPage';
import WidgetCard from '../components/WidgetCard';
import useMatchMedia from '../hooks/match-media';
import Paragraph from '../components/Paragraph';
import { useSizeColsIsRoot } from '../hooks/archive-hooks';
import FeedByRelationship from '../containers/FeedRelationshipPageTemplate';
import FeedWithHighlight from '../containers/FeedWithHighlight';

/** UTILS  */
const parsePageData = (data) => {
  const {
    title,
    slug,
    subtitle,
    content,
    coverImage,
    coverImageMobile,
    widgetCard,
    contentAccordion,
    treeParent,
    root,
    newsFeedModularBlock,
    seoMetaTags
  } = data;
  const model = data.model.name;
  const treeChildren = treeParent && treeParent.treeChildren;
  return {
    coverImage,
    coverImageMobile,
    widgetCard,
    title,
    slug,
    subtitle,
    content,
    contentAccordion,
    treeParent,
    treeChildren,
    root,
    model,
    seoMetaTags,
    newsFeedModularBlock: newsFeedModularBlock[0] ? newsFeedModularBlock[0] : {}
  };
};

const parseFeedByRelationship = (data) => {
  let relatedNews = [];
  if (data.newsByTopic && data.newsByTopic.nodes) {
    relatedNews = data.newsByTopic.nodes;
  } else if (data.newsByCategory && data.newsByCategory.nodes) {
    relatedNews = data.newsByCategory.nodes;
  }

  const sampleNews = relatedNews[0] ? relatedNews[0] : {};

  let relatedBy = '';
  if (data.newsByTopic) {
    relatedBy = 'topic';
  } else if (data.newsByCategory) {
    relatedBy = 'category';
  }

  return {
    list: relatedNews,
    sampleNews,
    relatedBy
  };
};

/** COMPONENT */
const PageTemplate = ({ data, pageContext }) => {
  const [isMobile, setIsMobile] = useState(false);

  const mediaToMatch = '(max-width: 1365px)';
  useMatchMedia(setIsMobile, mediaToMatch);
  const page = parsePageData(data.datoCmsPage); // For Page component
  const feedByRelationship = parseFeedByRelationship(data); // For FeedByRelationship
  const { newsHighlight } = page.newsFeedModularBlock; // CardHero
  const { apiKey } = page.newsFeedModularBlock.model
    ? page.newsFeedModularBlock.model : {}; // To check the feed to mount
  const { defaultRelatedNews } = { defaultRelatedNews: data.allDatoCmsNews.nodes };
  const { slug } = data.datoCmsNewsArchive;
  const { newsNumber } = page.newsFeedModularBlock;
  const { titleFeed } = { titleFeed: page.newsFeedModularBlock.title };

  const filteredRelatedNews = defaultRelatedNews.filter((news) => {
    // Filter all news different to the news in highlight
    if (!newsHighlight) return true;
    return news.slug !== newsHighlight.slug;
  });
  const cardHeroProps = {
    label: newsHighlight ? newsHighlight.topic.name : '',
    title: newsHighlight ? newsHighlight.title : '',
    labelButton: 'Scopri di più',
    image: (newsHighlight && newsHighlight.coverImage) ? newsHighlight.coverImage.fluid : '',
    alt: (newsHighlight && newsHighlight.coverImage) ? newsHighlight.coverImage.alt : '',
    url: newsHighlight ? `/${slug}/${newsHighlight.slug}` : ''
  };

  const feedProps = {
    title: 'home',
    url: slug,
    withHighlight: !!newsHighlight,
    labelLink: 'Vedi tutti',
    hasPadding: true,
    marginBottom: 'zero',
    marginTop: 'zero',
    hasBackground: true
  };

  const wrappedFeedProps = {
    feedProps,
    cardHeroProps,
    newsHighlight,
    newsFeedModularBlock: page.newsFeedModularBlock,
    defaultRelatedNews: filteredRelatedNews.slice(0, 9)
  };

  return (
    <Layout
      seoMetaTags={page.seoMetaTags}
      pathname={pageContext.pathname}
      communicationBar={pageContext.communicationBar}
      pageType="Page"
      canonical={pageContext.canonical}
    >
      <div className="page-template">
        <HeaderPage
          title={page.title}
          labelParent={page.treeParent}
          parentPathname={pageContext.parentPathname}
          isRoot={page.root}
          model={page.model}
          coverImage={page.coverImage}
          coverImageMobile={page.coverImageMobile}
          widgetCard={page.widgetCard}
        />
        <div className="page-wrapper">
          {
            page.widgetCard
            && isMobile
            && (
              <WidgetCard
                widgetCard={page.widgetCard}
              />
            )
          }
          <div className="page-wrapper__paragraph">
            <Paragraph
              subtitle={page.subtitle}
              content={page.content}
              contentAccordion={page.contentAccordion}
              marginTop="zero"
              marginBottom="zero"
              numCols={useSizeColsIsRoot(page.root)}
              root={page.root}
              pageSlug={page.slug}
              parentPathname={pageContext.parentPathname}
              treeParent={page.treeParent}
              treeChildren={page.treeChildren}
              activeNavigationSidebar
            />
          </div>
          {
            data && data.datoCmsPage && (
              <VisualComposer
                root={data.datoCmsPage.root}
                components={data.datoCmsPage.visualComposer}
              />
            )
          }
        </div>

        {apiKey === 'news_feed' && <FeedWithHighlight {...wrappedFeedProps} />}

        {apiKey === 'news_by_relationship' && feedByRelationship.list[0] && (
          <FeedByRelationship
            archiveSlug={slug}
            relatedNews={
              feedByRelationship.list.slice(0, newsNumber)
            }
            relatedNewsBy={feedByRelationship.relatedBy}
            news={feedByRelationship.sampleNews}
            titleFeed={titleFeed}
          />
        )}
      </div>
    </Layout>
  );
};

export default PageTemplate;
